/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import styles from './NPI.module.scss';
import { medicalProfession } from '../sharedcomponents/utils';

export type NPIRadioButtonProps = {
  onProfessionSelect: (profession: string) => void;
};

export default function NPIRadioButtons({ onProfessionSelect }: NPIRadioButtonProps) {
  const [checkedValue, setcheckedValue] = useState<string>('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setcheckedValue(event.target.value);
  };

  const onSubmit = () => {
    onProfessionSelect(checkedValue);
  };

  return (
    <>
      <FormControl component="fieldset">
        <RadioGroup value={checkedValue} onChange={handleChange}>
          {medicalProfession.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: 'var(--crystal)',
                    },
                  }}
                />
              }
              label={option.label}
            />
          ))}
        </RadioGroup>
      </FormControl>

      <Button disabled={!checkedValue} variant="contained" className={styles.professionSubmitButton} onClick={onSubmit}>
        Submit
      </Button>
    </>
  );
}
